'use client'
import { memo } from 'react'

import s from './MainCards.module.scss'
import Link from 'next/link'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'

interface IMainCardsProps {
    lightTheme?: boolean
}

export const MainCards = memo(({ lightTheme }: IMainCardsProps) => {
    const { t } = useTranslation()
    console.log('cards:', lightTheme)

    const data = [
        {
            title: t('cardAboutTestingOneTitle'),
            description: t('cardAboutTestingOneDescription'),
            links: [
                {
                    href: '/catalog',
                    text: t('productsCatalog')
                },

                {
                    href: '/b2b',
                    text: t('realization_of_materials')
                },
                {
                    href: '/export',
                    text: t('export')
                }
            ]
        },
        {
            title: t('cardAboutTestingTwoTitle'),
            description: t('cardAboutTestingTwoDescription'),
            links: [
                {
                    href: 'https://megakorm.ru',
                    text: t('megakorm')
                },
                {
                    href: ' https://a-korm.ru/',
                    text: t('akorm')
                },
                {
                    href: '/useful-materials',
                    text: t('usefulMaterialsTitle')
                }
            ]
        },
        {
            title: t('to_foreign_partners'),
            description: t('cardAboutTestingThreeDescription'),
            links: [
                {
                    href: '/labs',
                    text: t('labs')
                },
                {
                    href: '/consulting',
                    text: t('consulting')
                },
                {
                    href: '/consulting',
                    text: t('Technologies')
                }
            ]
        }
    ]
    const variants = {
        hidden: {
            transition: { duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 0,
            y: -3 * 3 * 3 * 3
        },
        visible: {
            transition: { duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 1,
            y: 0
        }
    }

    const blockVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            duration: 0.3,
            transition: {
                duration: 0.3,
                staggerChildren: 0.1 * 3 * 3 * 3 * 3 * 3 * 3
            }
        }
    }

    return (
        <motion.section
            initial={'hidden'}
            animate={'visible'}
            variants={blockVariants}
            className={s.wrapper}
        >
            {data.map(el => {
                return (
                    // <div className={'main-about__card ' + s.car }>
                    <motion.div
                        initial={'hidden'}
                        animate={'visible'}
                        variants={variants}
                        className={classNames('main-about__card ', s.car, lightTheme ? s.light : '')}
                    >
                        <h3 className={classNames(s.header, lightTheme ? s.lightColor : '')}> {el.title}</h3>
                        <p className={classNames(s.tex, lightTheme ? s.lightColor : '')}>{el.description}</p>
                        <div className={s.links}>
                            {el.links.map(link => {
                                return (
                                    <Link
                                        href={link.href}
                                        className={classNames(s.lin, lightTheme ? s.lightlink : '')}
                                    >
                                        {link.text}
                                        <svg
                                            width='6'
                                            height='11'
                                            viewBox='0 0 6 11'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                            style={{ marginLeft: 15 }}
                                        >
                                            <path
                                                d='M1 10L4.94095 5.56644C4.97462 5.52855 4.97462 5.47145 4.94095 5.43356L1 1'
                                                stroke='#FEAA9F'
                                                stroke-width='2'
                                                stroke-linecap='round'
                                            />
                                        </svg>
                                    </Link>
                                )
                            })}
                        </div>
                    </motion.div>
                )
            })}
        </motion.section>
    )
})
